import { useState } from "react";
import { Box, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import GroupIcon from "@mui/icons-material/Group";
import backgroundWhatsApp from "../../assets/background_whatsapp.png";
import api from "../../utils/api";

const WhatsAppCommunityCard = ({ userId, onClose }) => {
  const [isClosing, setIsClosing] = useState(false);

  const handleClose = () => {
    // Fecha o card imediatamente para melhor UX
    if (onClose) {
      onClose();
    }

    // Faz a requisição em background
    if (userId) {
      api.post(`/talents/talents/${userId}/dismiss_community_card`)
        .then((response) => {
          console.info("Card da comunidade fechado com sucesso:", response);
        })
        .catch((error) => {
            console.error("Erro ao fechar card da comunidade:", error.response?.data || error.message);
        });
    }
  };

  return (
    <div
      className="whatsapp-wrapper anamitionCard"
      style={{
        backgroundImage: `url(${backgroundWhatsApp})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        borderRadius: "10px",
        padding: "15px 20px",
        width: "100%",
        maxWidth: "80vw",
        position: "relative",
      }}
    >
      {/* Ícone Group decorativo */}
      <Box
        className="anamitionCard"
        sx={{
          position: "absolute",
          top: "60px",
          right: "10px",
          zIndex: 5,
        }}
      >
        <Box
          sx={{
            backgroundColor: "#DDF5DB",
            borderRadius: "8px",
            padding: "8px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            boxShadow: "0 2px 6px rgba(0, 0, 0, 0.15), 0 0 0 rgba(0, 0, 0, 0)",
          }}
        >
          <GroupIcon sx={{ color: "#646464", fontSize: "18px" }} />
        </Box>
      </Box>

      {/* Ícone de três pontinhos decorativo */}
      <Box
        className="anamitionCard"
        sx={{
          position: "absolute",
          bottom: "50px",
          left: "5px",
          zIndex: 5,
        }}
      >
        <Box
          sx={{
            backgroundColor: "#DDF5DB",
            borderRadius: "16px",
            padding: "10px 12px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            boxShadow: "0 2px 6px rgba(0, 0, 0, 0.15), 0 0 0 rgba(0, 0, 0, 0)",
          }}
        >
          <Box
            sx={{
              display: "flex",
              gap: "4px",
              alignItems: "center",
            }}
          >
            <Box
              sx={{
                width: "5px",
                height: "5px",
                backgroundColor: "#646464",
                borderRadius: "50%",
              }}
            />
            <Box
              sx={{
                width: "5px",
                height: "5px",
                backgroundColor: "#646464",
                borderRadius: "50%",
              }}
            />
            <Box
              sx={{
                width: "5px",
                height: "5px",
                backgroundColor: "#646464",
                borderRadius: "50%",
              }}
            />
          </Box>
        </Box>
      </Box>

      {/* Card principal */}
      <div className="containerHabilits anamitionCard whatsapp-container">
        <IconButton
          onClick={handleClose}
          disabled={isClosing}
          sx={{
            position: "absolute",
            top: "8px",
            right: "8px",
            color: "#666666",
            backgroundColor: "transparent",
            "&:hover": {
              backgroundColor: "rgba(0, 0, 0, 0.05)",
            },
            zIndex: 10,
            width: "32px",
            height: "32px",
            padding: "4px",
          }}
        >
          <CloseIcon sx={{ fontSize: "20px", fontWeight: "bold" }} />
        </IconButton>
        <Box
          sx={{
            width: "100%",
            height: "100%",
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <div className="textTitle whatsapp-title">Acesse a nossa comunidade</div>
          <div className="textProfileSUb2 whatsapp-description">
            Conecte-se com talentos de elite, troque experiências e turbine a sua carreira.
          </div>

          <button
            onClick={() => {
              window.open("https://chat.whatsapp.com/Fn0wX5NF25hAqlknWNklT2", "_blank");
            }}
            className="buttonCardHome whatsapp-button"
            style={{ marginTop: "12px" }}
          >
            <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
              <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893A11.821 11.821 0 0020.885 3.488"/>
            </svg>
            Juntar-se à Comunidade Agora!
          </button>
        </Box>
      </div>
    </div>
  );
};

export default WhatsAppCommunityCard;
